import { Fragment, useEffect, useRef, useState } from 'react';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { ClientMenu } from '../config/ClientMenu';
import { TreeNode } from 'primereact/treenode';
import { SideMenu } from '../models/SideMenu';
import { InputSwitch } from 'primereact/inputswitch';
import { ClientMobileMenu } from '../config/ClientMobileMenu';

interface inputPrams {
  policies: {
    changes: boolean,
    policies: string[]
  },
  setPolicies: any,
  isPortal: boolean
}


export default function AccessLevelTree(props: inputPrams) {

  const menu = props.isPortal ? ClientMenu : ClientMobileMenu;

  const nodes = mapSideMenuToNode(menu, props.policies.policies);


  const actionTemplate = (row: TreeNode) => {
    return (
      <div className="flex flex-wrap gap-2">
        <InputSwitch checked={row.data.active} onChange={(e) => {
          let key = row.key as string;
          let policies = props.policies.policies;
          if (key.includes('*')) {
            key = key.replace(':*', '');
            if (e.value) {
              policies = policies.concat([
                `${key}:add`,
                `${key}:update`,
                `${key}:delete`
              ]);
            } else {
              removePolicies(policies, `${key}:add`);
              removePolicies(policies, `${key}:update`);
              removePolicies(policies, `${key}:delete`);
            }
          } else {
            if (e.value) {
              policies = policies.concat(key);
            } else {
              const index = policies.indexOf(key);
              policies.splice(index, 1);
            }
          }
          props.setPolicies({
            changes: !props.policies.changes,
            policies: policies
          });
        }} />
      </div>
    );
  };

  return (
    <Fragment>
      <TreeTable value={nodes} tableStyle={{ minWidth: '50rem' }}>
        <Column field="label" header="Item" expander></Column>
        <Column body={actionTemplate} field="active" header="Access">
        </Column>
      </TreeTable>
    </Fragment>
  );
}

function mapSideMenuToNode(menu: SideMenu[], policies: string[]): TreeNode[] {
  let treeNode: TreeNode[] = [];
  menu.forEach(((item, i) => {
    const active = policies.includes(`${item.policy}:add`) && policies.includes(`${item.policy}:update`) && policies.includes(`${item.policy}:delete`);
    treeNode.push({
      key: `${item.policy}:*`,
      label: item.label,
      data: { ...item, ...{ active } },
      children: nodeChildren(item, policies)
    })
  }));
  return treeNode;
}

function removePolicies(policies: string[], key: string) {
  policies.forEach((item, index) => {
    if (item === key) policies.splice(index, 1);
  });
}


function nodeChildren(menu: SideMenu, policies: string[]): TreeNode[] {
  return [];
  // [{
  //   key: `${menu.policy}:view-only`,
  //   label: 'View',
  //   data: {
  //     label: 'Allow View Only',
  //     active: policies.includes(`${menu.policy}:view-only`)
  //   },
  // },
  // {
  //   key: `${menu.policy}:add`,
  //   label: 'Add',
  //   data: {
  //     label: 'Allow Add',
  //     active: policies.includes(`${menu.policy}:add`)
  //   },
  // },
  // {
  //   key: `${menu.policy}:update`,
  //   label: 'Update',
  //   data: {
  //     label: 'Allow Update',
  //     active: policies.includes(`${menu.policy}:update`)
  //   },
  // },
  // {
  //   key: `${menu.policy}:delete`,
  //   label: 'Delete',
  //   data: {
  //     label: 'Allow Delete',
  //     active: policies.includes(`${menu.policy}:delete`)
  //   },
  // }];
}